<template>
  <div class="detil">
    <CQuestionnaire
      ref = 'question'
      :moId = '_qsDetailQueryProps.moId'
      :mtId = '_qsDetailQueryProps.mtId'
      :busType = '_qsDetailQueryProps.busType'
      :tenantId = '_qsDetailQueryProps.tenantId'
      :businessKey = '_qsDetailQueryProps.businessKey'
      :isPreview = '_qsDetailQueryProps.isPreview'
    />
  </div>
</template>

<script>
export default {
  name: 'qsDetil',
  props:{
    _qsDetailQueryProps: Array
  },
  data(){
    return {
    }
  }
}
</script>

<style scoped lang="stylus">
.detil
  overflow hidden
  background-color #fff
  height 100%
  width 100%
  box-sizing border-box
  padding 10px 16px

</style>